module.exports = __webpack_public_path__ + "static/media/vietnam.f23a4564.svg";